class ZtnaWhitepaper {
    constructor() {
        this.modal = document.getElementById('ztna_whitepaper_modal');
        if(this.modal){
            new bootstrap.Modal(this.modal, {}).show()
        }

        this.closeModal();
        this.clickButton();
        this.remindMeLater();
    }
    closeModal(){
        $(this.modal).on('hide.bs.modal', function () {
            $('#ztna-closed-whitepaper').show();
        });

        let gotItButton = document.getElementById('ztna-closed-whitepaper-got-it');
        gotItButton.addEventListener('click', function () {
            $('#ztna-closed-whitepaper').hide();
        });
    }
    clickButton(){
        let thisClass = this;
        let exploreZtnaWhitepaper = this.modal.querySelector('.explore-ztna-whitepaper');
        if(exploreZtnaWhitepaper){
            exploreZtnaWhitepaper.addEventListener('click', function () {
                window.open('https://www.goodaccess.com/whitepapers/practical-guide-implementing-zero-trust-security', '_blank');
                $(thisClass.modal).off('hide.bs.modal');
                $.ajax({
                    url: '?do=ztnaWhitepaper',
                    type: 'GET',
                    data: {
                        click: true
                    }
                });
            });
        }
    }
    remindMeLater(){
        let thisClass = this;
        let remindMeLater = this.modal.querySelector('.remind-me-later');
        if(remindMeLater){
            remindMeLater.addEventListener('click', function () {
                $(thisClass.modal).off('hide.bs.modal');
                bootstrap.Modal.getOrCreateInstance(thisClass.modal).hide();
                $.ajax({
                    url: '?do=ztnaWhitepaper',
                    type: 'GET',
                    data: {
                        remindMeLater: true
                    }
                });
            });
        }
    }
}

window.ZtnaWhitepaper = ZtnaWhitepaper;